import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AlertService from "../services/alert.service";
import { setMessage } from "./alertMessageSlice";
import { getPersonalDetails } from "./tenantSettingSlice";


export const updateAlert = createAsyncThunk(
    "alert/updateAlert",
    async ({ body }, thunkAPI) => {
        try {

            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.UpdateAlert(brandUser?.tenant_id, body?.id, body);
            await thunkAPI.dispatch(getAllAlert());
            await thunkAPI.dispatch(getConfiguredAlerts());
            return { ...data };
        } catch (error) {
            console.log(error?.response?.data?.detail?.message, "error");

            const check_if_alert = error?.response?.data?.detail?.error_status
            const message =
                (error?.response &&
                    error?.response?.data &&
                    (error?.response?.data?.detail?.message) ||
                    (error?.response?.data?.message || error?.response?.data?.detail?.[0]?.msg) || error?.response?.data?.detail) ||
                error.message ||
                error.toString();
            console.log(message, "message");
            thunkAPI.dispatch(setMessage({ message: message, type: 'rejected' }));
            // return thunkAPI.rejectWithValue();
            return thunkAPI.rejectWithValue({
                check_if_alert
            });
        }
    }
);

export const createAlert = createAsyncThunk(
    "alert/createAlert",
    async ({ body }, thunkAPI) => {
        try {

            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.CreateAlert(brandUser?.tenant_id, body);
            await thunkAPI.dispatch(getAllAlert());
            await thunkAPI.dispatch(getConfiguredAlerts());
            return { ...data };
        } catch (error) {
            console.log(error?.response?.data?.detail?.message, "error");

            const check_if_alert = error?.response?.data?.detail?.error_status
            const message =
                (error?.response &&
                    error?.response?.data &&
                    (error?.response?.data?.detail?.message) || (error?.response?.data?.errors?.[0]?.message) ||
                    (error?.response?.data?.message || error?.response?.data?.detail?.[0]?.msg) || error?.response?.data?.detail) ||
                error.message ||
                error.toString();
            console.log(message, "message");
            thunkAPI.dispatch(setMessage({ message: message, type: 'rejected' }));
            // return thunkAPI.rejectWithValue();
            return thunkAPI.rejectWithValue({
                check_if_alert
            });
        }
    }
);

export const getAllAlert = createAsyncThunk(
    "alert/getAllAlert",
    async (_, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.GetAllAlert(brandUser?.tenant_id);
            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const getConfiguredAlerts = createAsyncThunk(
    "alert/getConfiguredAlerts",
    async (_, thunkAPI) => {
        try {
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.getConfiguredAlerts(brandUser?.tenant_id);
            return data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const updateAlertStatus = createAsyncThunk(
    "alert/updateAlertStatus",
    async (body, thunkAPI) => {
        try {
            const alert_id = body?.alert_id;
            const payload = { status: body?.status }
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.updateAlertStatus(brandUser?.tenant_id, alert_id, payload);

            thunkAPI.dispatch(setMessage({ message: 'Successfully updated', type: 'success' }));
            await thunkAPI.dispatch(getAllAlert());
            return data;
        } catch (error) {
            let message = error?.response?.data?.detail || error?.response?.data || error.message
            thunkAPI.dispatch(setMessage({ message: message ,type :'rejected'}));
            
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteAlertStatus = createAsyncThunk(
    "alert/deleteAlertStatus",
    async (body, thunkAPI) => {
        try {
            const alert_id = body?.alert_id;
            const payload = { status: body?.status }
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.deleteAlertStatus(brandUser?.tenant_id, alert_id, payload);

            thunkAPI.dispatch(setMessage({ message: 'Alert Deleted Successfully', type: 'success' }));
            await thunkAPI.dispatch(getAllAlert());
            return data;
        } catch (error) {
            // return thunkAPI.rejectWithValue(error?.response?.data || error.message);
            let message = error?.response?.data?.detail || error?.response?.data || error.message
            thunkAPI.dispatch(setMessage({ message: message ,type :'rejected'}));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const updatePhoneNumber = createAsyncThunk(
    "alert/updatePhoneNumber",
    async (body, thunkAPI) => {
        try {
            const payload = { phone_number: body?.phone_number,country_code:body?.country_code }
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.updatePhoneNumber(brandUser?.tenant_id, brandUser?.user_details?.user_id, payload);
            console.log(data,"data in updatePhoneNumber");
            if(data?.status == 'error'){
                thunkAPI.dispatch(setMessage({ message: data?.message, type: 'rejected' }));

            }else{
                thunkAPI.dispatch(setMessage({ message:data?.message, type: 'success' }));
            

            }
            
            await thunkAPI.dispatch(getPersonalDetails());
            // await thunkAPI.dispatch(setPhoneDis(body?.phone_number));
            // await thunkAPI.dispatch(setPhoneDis(body?.phone_number));
            return data;
        } catch (error) {
            console.log(error,"error in sss");
            
            let message = error?.response?.data?.errors?.[0]?.message  || error?.response?.data?.detail || error?.response?.data || error.message || ''
            console.log(message,"message");
            
            thunkAPI.dispatch(setMessage({ message: message ,type :'rejected'}));
            await thunkAPI.dispatch(getPersonalDetails());
            
            // return thunkAPI.rejectWithValue(message);
        }
    }
);


export const resendOtp = createAsyncThunk(
    "alert/resendOtp",
    async (body, thunkAPI) => {
        try {
            // const payload = { otp: body?.otp }
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.resendOtp(brandUser?.tenant_id, brandUser?.user_details?.user_id);
            console.log(data,"data in resendOtp");
            // thunkAPI.dispatch(setShowVerifyOtp(false));
            if(data?.status == 'error'){
                thunkAPI.dispatch(setMessage({ message: data?.message, type: 'rejected' }));

            }else{
                thunkAPI.dispatch(setMessage({ message:data?.message, type: 'success' }));
            

            }
            await thunkAPI.dispatch(getPersonalDetails());

            return data;
        } catch (error) {
            let message = error?.response?.data?.detail || error?.response?.data || error.message
            thunkAPI.dispatch(setMessage({ message: message ,type :'rejected'}));
            
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const verifyOtp = createAsyncThunk(
    "alert/verifyOtp",
    async (body, thunkAPI) => {
        try {
            const payload = { otp: body?.otp }
            const brandUser = JSON.parse(sessionStorage.getItem("brandUser"));
            const data = await AlertService.verifyOtp(brandUser?.tenant_id, brandUser?.user_details?.user_id, payload);
            console.log(data,"data in verifyOtp");
            if(data?.status == "error"){

            thunkAPI.dispatch(setMessage({ message: data?.message || '', type: 'rejected' }));
            }else{
            thunkAPI.dispatch(setShowVerifyOtp(false));
            thunkAPI.dispatch(setMessage({ message: 'Successfully updated', type: 'success' }));
            await thunkAPI.dispatch(getPersonalDetails());

            }

            return data;
        } catch (error) {
            let message = error?.response?.data?.detail || error?.response?.data || error.message
            thunkAPI.dispatch(setMessage({ message: message ,type :'rejected'}));
            
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const initialState = {
    alertsList: null,
    loading: false,
    error: null,
    configureAlert: null,
    editAlert: null,
    errorChecker: null,
    upDatPho:null,
    showVerifyOtp:false,
    phone:null,
};

const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers: {

        setEditData: (state, action) => {
            state.editAlert = action.payload;
        },
        setEditEmpty: (state, action) => {
            state.editAlert = null;
        },

        setErrorChecker: (state, action) => {
            state.errorChecker = action.payload;
        },
        setShowVerifyOtp: (state, action) => {
            state.showVerifyOtp = action.payload;
        },
        setPhoneDis: (state, action) => {
            state.phone = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // createAlert
            .addCase(createAlert.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAlert.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(createAlert.rejected, (state, action) => {
                state.loading = false;
                console.log(action.payload,"action.payload");
                
                state.errorChecker = action.payload?.check_if_alert;
            // thunkAPI.dispatch(setErrorChecker(check_if_alert));
                state.error = action.payload || "Failed to create alert";
            })
            .addCase(updateAlert.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAlert.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(updateAlert.rejected, (state, action) => {
                state.loading = false;
                console.log(action.payload,"action.payload");
                
                state.errorChecker = action.payload?.check_if_alert;
            // thunkAPI.dispatch(setErrorChecker(check_if_alert));
                state.error = action.payload || "Failed to create alert";
            })

            // getAllAlert
            .addCase(getAllAlert.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllAlert.fulfilled, (state, action) => {
                state.loading = false;
                state.alertsList = Array.isArray(action.payload)
                    ? action.payload.filter(
                        (alert) => alert.is_active === 0 || alert.is_active === 1
                    )
                    : [];
            })
            .addCase(getAllAlert.rejected, (state, action) => {
                state.loading = false;
                state.alertsList = null;
                state.error = action.payload || "Failed to fetch alerts";
            })


            // getConfiguredAlerts
            .addCase(getConfiguredAlerts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getConfiguredAlerts.fulfilled, (state, action) => {
                state.loading = false;
                state.configureAlert = action.payload;
            })
            .addCase(getConfiguredAlerts.rejected, (state, action) => {
                state.loading = false;
                state.configureAlert = null;
                state.error = action.payload || "Failed to fetch alerts";
            })
            
            
            .addCase(resendOtp.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.showVerifyOtp = false;
            })
            .addCase(resendOtp.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action?.payload,'action.payload in resendOtp');
                if(action?.payload?.status == 'pending'){
                    state.showVerifyOtp = true
                }
                // if(action?.payload?.status == 'error'){
                // state?.showVerifyOtp = false
                    
                // }else{
                // state.upDatPho = action.payload;
                // state.showVerifyOtp = true

                // }
            })
            .addCase(resendOtp.rejected, (state, action) => {
                state.loading = false;
                state.upDatPho = null;
                state.showVerifyOtp = false;
            })
            .addCase(updatePhoneNumber.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.showVerifyOtp = false;
            })
            .addCase(updatePhoneNumber.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload,'action.payload in updatePhoneNumber');
                if(action.payload == undefined){
                state.showVerifyOtp = false
                }else if((action.payload?.status == 'error') || (action.payload?.status == 'failed')){
                state.showVerifyOtp = false
                    
                }else{
                state.upDatPho = action.payload;
                state.showVerifyOtp = true

                }
            })
            .addCase(updatePhoneNumber.rejected, (state, action) => {
                state.loading = false;
                state.upDatPho = null;
                state.showVerifyOtp = false;
            })
            
            .addCase(verifyOtp.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyOtp.fulfilled, (state, action) => {
                state.loading = false;
            })

            .addCase(updateAlertStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAlertStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.configureAlert = action.payload;
            })

            .addCase(deleteAlertStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAlertStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.configureAlert = action.payload;
            })

    },
});



export const {
    setEditData,
    setEditEmpty,
    setErrorChecker,
    setShowVerifyOtp
} = alertSlice.actions;

export default alertSlice.reducer;
